//node modules


//components
import {Button, Spinner} from "reactstrap";
import {httpsCallable} from "firebase/functions";
import {Auth, Functions} from "../../../../firebase/firebase";
import {useState} from "react";

//validators


export default function TriggerCheckCampaignEnd() {
  const [processing, setProcessing] = useState(false);

  async function check() {
    setProcessing(true);
    httpsCallable(Functions, "call-system-campaign-checkCampaignStatus")({
      callerID: Auth.currentUser?.uid || null,
      callerToken: await Auth.currentUser?.getIdToken() || null,
    })
      .then(() => {
        setProcessing(false);
      });
  }

  return (
    <>
      <Button style={{marginTop: "10px", textAlign: "center"}} color={"plain"} onClick={() => check()}>
        {!processing ? (
          <>Sjekk Kampanjer</>
        ) : (
          <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
            <Spinner style={{width: "20px", height: "20px"}}/>
          </div>
        )}
      </Button>
    </>
  )
}
